export const SCREEN_CARD_WIDTH = 256; // px
export const SCREEN_CARD_THUMBNAIL_WIDTH = 256; // px
